import { render, staticRenderFns } from "./LocalPagination.vue?vue&type=template&id=082a61d2&scoped=true"
import script from "./LocalPagination.vue?vue&type=script&lang=js"
export * from "./LocalPagination.vue?vue&type=script&lang=js"
import style0 from "./LocalPagination.vue?vue&type=style&index=0&id=082a61d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a61d2",
  null
  
)

export default component.exports